<template>
  <div id="footer-page">
    <!-- Footer -->
    <footer :class="classFooter">
      <div class="container">
        <div class="row gap-y">
          <div class="col-md-6 col-xl-4">
            <p>
              <a href="#"><img
                src="../assets/landings/logo/abler-default.svg"
                class="w-40"
                alt="logo"
              ></a>
            </p>
            <p>Software de Recrutamento e Seleção que auxilia empresas a encontrarem profissionais qualificados para enriquecer seu Employer Branding reduzindo custos e tempo.</p>
          </div>

          <div class="col-6 col-md-3 col-xl-2">
            <h6 class="mb-4 mt-1">
              <strong class="font-weight-bold">para empresas</strong>
            </h6>
            <div class="nav flex-column">
              <a
                class="nav-link"
                :href="`${protocol}${currentdomain}/para-empresa`"
              >como funciona</a>
              <a
                class="nav-link"
                :href="`${protocol}${currentdomain}/produto`"
                target="_blank"
              >produto</a>
              <a
                class="nav-link"
                href="https://meet.jit.si"
                target="_blank"
              >entrevista online</a>
            </div>
          </div>

          <div class="col-6 col-md-3 col-xl-2">
            <h6 class="mb-4 mt-1">
              <strong class="font-weight-bold">para candidatos</strong>
            </h6>
            <div class="nav flex-column">
              <a
                class="nav-link"
                :href="`${protocol}candidatos.${currentdomain}/vagas`"
              >vagas</a>
              <a
                class="nav-link"
                :href="`${protocol}candidatos.${currentdomain}/sign-up`"
                target="_blank"
              >cadastre-se</a>
              <a
                class="nav-link"
                href="https://help.abler.com.br/"
                target="_blank"
              >FAQ</a>
            </div>
          </div>

          <div class="col-6 col-md-3 col-xl-2">
            <h6 class="mb-4 mt-1">
              <strong class="font-weight-bold">sobre nós</strong>
            </h6>
            <div class="nav flex-column">
              <a
                class="nav-link"
                :href="`${protocol}${currentdomain}/quem-somos`"
              >quem somos</a>
              <a
                class="nav-link"
                :href="`${protocol}trabalheconosco.${currentdomain}`"
              >trabalhe conosco</a>
              <a
                class="nav-link"
                :href="`${protocol}${currentdomain}/blog`"
                target="_blank"
              >blog</a>
            </div>
          </div>

          <div class="col-6 col-md-6 col-xl-2 text-center">
            <p class="d-none d-sm-block mb-3">
              <a
                v-if="subdomain == 'empresas'"
                :class="classBtnFooter"
                size="sm"
                href="#form"
                target="_blank"
              >
                <small>Entre em contato</small>
              </a>
            </p>
            <div class="social">
              <a
                class="social-facebook my-2"
                href="https://www.facebook.com/ableroficial"
              ><i class="fab fa-facebook-square fa-lg" /></a>
              <a
                class="social-twitter my-2"
                href="https://twitter.com/Ablerdigital"
              ><i class="fab fa-twitter fa-lg" /></a>
              <a
                class="social-instagram my-2"
                href="https://www.instagram.com/ableroficial"
              ><i class="fab fa-instagram fa-lg" /></a>
              <a
                class="social-linkedin my-2"
                href="https://www.linkedin.com/company/ableroficial"
              ><i class="fab fa-linkedin fa-lg" /></a>
            </div>
          </div>
        </div>
      </div>
    </footer><!-- /.footer -->
  </div>
</template>

<script>
import mixins from '../mixins/mixins';

export default {
  name: 'PageFooter',
  mixins: [mixins],
  data() {
    return {
      classFooter: {
        footer: true,
        'bg-color-gray': true,
        'py-7': true,
      },
      classBtnFooter: {
        btn: true,
        'btn-round': true,
        'btn-success': true,
        'bg-color-primary': true,
        'w-100': true,
        'px-0': true,
      },
      message: 'footer-component',
      textButton: '',
      currentdomain: '',
      separate: window.location.host.split('.'),
    };
  },

  mounted() {
    this.separate.shift();
    this.currentdomain = this.separate.join('.');
  },
};
</script>

<style lang="scss" scoped>
  #footer-page {
    .footer {
      .btn {
        box-shadow: none !important;
        outline: none !important;
        border: 0;
      }
    }

    .bg-color-gray {
      background-color: #f4f5f6;
    }
  }
</style>
